<div class="external-auth" *ngIf="isProcessing">
  <div class="external-auth__card">
    <div class="external-auth__spinner" aria-hidden="true"></div>
    <p class="body14 slate-600 text-center">{{'general.google_signing_in' | translate}}</p>
  </div>
</div>
